const defaultState = {
  severity: "info",
  text: "",
  open: false,
};

const alertComponentReducer = (state = defaultState, action) => {
    
  switch (action.type) {
    case "UPDATE_ALERT":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return { ...state };
  }
};

export default alertComponentReducer;
